<avi-dropdown
    name="metric-values-selector"
    [(ngModel)]="metricValue"
    [options]="options"
    prepend="{{ globalL10nKeys.valueLabel | vtranslate }}"
    placeholder="{{ l10nKeys.selectValuePlaceholder | vtranslate }}"
    [required]="true"
    (ngModelChange)="handleChange()"
></avi-dropdown>
